export default "__VITE_ASSET__3mS6kE9R__"